module.exports = __webpack_public_path__ + "static/media/FillerupLogo.a88f16d9.png";